import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import ArrowRightOrange from '../../assets/images/common/arrow-right-orange.svg';
import IconCopy from '../../assets/images/common/icon-copy.svg';

import { SCREEN_NAME, TS_SCREEN, TEMP_TYPE } from '../../types/common/CommonType';

import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { EditEstimateRow } from './EditEstimateRow';
import { EditEstimateRowLogic } from './editEstimateRowLogic';
import { CoverProgressLoading } from '../../components/CoverProgressLoading';
import { TempSaveButton } from '../../components/TempSaveButton';
import { ErrorModalModal } from '../../components/ErrorModal';
import { setState as setScreenTransition } from '../../slice/ScreenTransitionSlice';
import { addRow as setMoveScreen } from '../../slice/ScreenHistorySlice';
import { estimateApi } from '../../api/estimate';

export const EditEstimate = () => {
    const navigation = useNavigate();
    const dispatch = useAppDispatch();
    const { draftInquiryEstimateId } = useParams();

    // API実行状況管理
    const [loadingStatus, setLoadingStatus] = useState<boolean>(false);
    // 各エラー管理
    const [errorMessages, setErrorMessages] = useState<Array<string>>([]);
    const [openErrorModal, setOpenErrorModal] = useState<boolean>(false);
    // 見積問合せ
    const estimateInquiry = useAppSelector((s) => s.EstimateInquiry);
    // 保守レベルマスタ取得
    const masterSla = useAppSelector((s) => s.MasterSla);
    // 都道府県、市区町村のマスタ
    const masterPrefecture = useAppSelector((s) => s.MasterPrefecture);
    // state更新方法のコレクションを生成
    const estSetState = EditEstimateRowLogic.generateSetState(dispatch, estimateInquiry);

    // 画面遷移ルート追加
    useEffect(() => {
        dispatch(setMoveScreen(SCREEN_NAME.EDIT_ESTIMATION));
        // 一時保存からの復帰制御
        if (draftInquiryEstimateId) {
            const draftDataSet = async () => {
                const getDarftRet = await estimateApi.getDraftEstimate(draftInquiryEstimateId, dispatch);
                if (getDarftRet !== '') {
                    setErrorMessages([getDarftRet]);
                    setOpenErrorModal(true);
                }
            };
            void draftDataSet();
        }
    }, []);

    // ローディングステータス管理
    useEffect(() => {
        // マスタが取得できていればローディングステータス更新
        if (masterPrefecture.prefecture.length > 0 && masterSla.length > 0) {
            setLoadingStatus(true);
        }
    }, [masterPrefecture, masterSla]);

    // お客様情報入力ボタンアクション
    const moveCustomerInformationButton = () => {
        // バリデーション
        const validationResult = EditEstimateRowLogic.validateEstimation(estimateInquiry, false);
        if (validationResult.length > 0) {
            setErrorMessages(validationResult);
            setOpenErrorModal(true);
        } else {
            // 画面遷移種別を更新
            dispatch(setScreenTransition(TS_SCREEN.EST));
            navigation('/customerInformation');
        }
    };

    return (
        <>
            {loadingStatus ? (
                <>
                    <div className='edit-estimate'>
                        <h2>見積りリスト</h2>
                        <p className='edit-estimate-description'>
                            選択頂いた機器に保守期間と保守レベルを選択してお見積りの条件を入力してください。
                            <br />
                            別の見積条件を追加したい場合、<strong>『見積り条件追加』</strong>
                            ボタンから見積の追加ができます。
                        </p>
                        {estimateInquiry.estimatePatternList.length === 0 ? (
                            <></>
                        ) : (
                            estimateInquiry.estimatePatternList.map((estimatePattern, index) => {
                                return (
                                    <React.Fragment
                                        key={`editEstimate-estimatePatternList-${estimatePattern.estimatePatternRowNumber}-${index}`}
                                    >
                                        <EditEstimateRow
                                            setState={estSetState}
                                            rowNumber={index + 1}
                                            masterPrefecture={masterPrefecture}
                                            masterSla={masterSla}
                                            estimatePattern={estimatePattern}
                                            inputMode={true}
                                            patternListLength={estimateInquiry.estimatePatternList.length}
                                            deviceList={estimateInquiry.deviceList}
                                        />
                                    </React.Fragment>
                                );
                            })
                        )}
                        <div className='edit-estimate-row-copy'>
                            <button
                                className='edit-estimate-row-copy-button'
                                onClick={estSetState.addStateEstimatePattern}
                                disabled={estimateInquiry.deviceList.length === 0}
                            >
                                見積り条件追加
                                <span className='icon is-small copy-icon'>
                                    <img src={IconCopy} alt='' />
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className='bottom_cta--next'>
                        <TempSaveButton
                            estimateInquiry={estimateInquiry}
                            tempSaveType={TEMP_TYPE.ESTIMETE_TEMP}
                        />
                        <a className='button is-dl_blue' onClick={moveCustomerInformationButton}>
                            お客様情報を入力する
                            <span className='icon is-small'>
                                <img src={ArrowRightOrange} alt='' />
                            </span>
                        </a>
                    </div>
                    <ErrorModalModal
                        openState={openErrorModal}
                        setOpenState={setOpenErrorModal}
                        errorMessages={errorMessages}
                    />
                </>
            ) : (
                <CoverProgressLoading />
            )}
        </>
    );
};
